<template>
  <div class="overflow-auto flex flex-col items-stretch justify-start p-8">
    <div class="flex flex-col items-stretch justify-start gap-10">
      <div class="flex flex-col items-center justify-start gap-3">
        <svg-icon iconName="tick-circle-icon" className="text-blueG0 !w-17.5 !h-17.5"></svg-icon>
        <div class="text-xl text-center text-blackG2 font-bold">
          {{ $t('register.demo.congrad') }}, {{ $t('register.demo.title', { platform: downloadLinks.type }) }} !
        </div>
      </div>
      <div class="flex flex-col items-center justify-center py-5 rounded-xl bg-blueG0 bg-opacity-5">
        <table class="infoTable">
          <tr>
            <td>{{ $t('register.demo.li.login') }}</td>
            <td>{{ account }}</td>
          </tr>
          <tr>
            <td>{{ $t('register.demo.li.srv') }}</td>
            <td>{{ server }}</td>
          </tr>
        </table>
      </div>
      <div class="flex flex-col items-center justify-center text-center mb-4 gap-4">
        <el-button
          class="blue_button min-w-55"
          @click="
            () => {
              $router.push(registerPath);
            }
          "
        >
          {{ $t('register.demo.openLiveAcc') }}
        </el-button>
        <div class="text-sm text-grayG0">{{ $t('register.demo.emailSent') }}</div>
      </div>
    </div>
    <el-divider class="my-10 flex-none"></el-divider>
    <div class="flex items-center justify-between gap-8">
      <div class="text-sm text-black">
        {{ $t('register.demo.dl', { platform: downloadLinks.type }) }}
      </div>
      <div class="w-100 flex items-center justify-between">
        <a
          v-for="platform in Object.keys(downloadPlatforms)"
          :key="platform"
          target="_blank"
          :href="downloadLinks[platform]"
          rel="noopener noreferrer"
          :data-testid="downloadPlatforms[platform].dataTestId(downloadLinks.type)"
          class="group/platformButton flex flex-col items-center justify-center gap-1"
        >
          <div
            class="flex items-center justify-center w-8 h-8 rounded-full border-none bg-darkBlueG0 bg-opacity-5 group-hover/platformButton:bg-lightBlueG0 group-hover/platformButton:bg-opacity-100"
          >
            <svg-icon :iconName="downloadPlatforms[platform].icon" className="!w-5 !h-5 text-darkBlueG0" />
          </div>
          <div class="text-xs text-black">{{ $t(downloadPlatforms[platform].label) }}</div></a
        >
      </div>
    </div>
  </div>
</template>

<script>
import { RegisterRoutePath } from '@/router/registerRoutes';

const downloadPlatforms = {
  windows: {
    icon: 'windows',
    label: 'downloads.windows',
    dataTestId: type => `windows${type}`
  },
  iphone: {
    icon: 'mac',
    label: 'downloads.ip',
    dataTestId: type => `iphone${type}`
  },
  android: {
    icon: 'android',
    label: 'downloads.android',
    dataTestId: type => `android${type}`
  },
  web: {
    icon: 'web',
    label: 'downloads.web',
    dataTestId: type => `web${type}`
  }
};

export default {
  name: 'AccountCreationResult',
  props: {
    account: { type: String, default: '' },
    server: { type: String, default: '' },
    downloadType: { type: String, default: 'mt4' }
  },
  computed: {
    downloadLinks() {
      const urls = this.$config.getMetaTraderLinks(this.$store.state.common.regulator);
      switch (this.downloadType) {
        case 'mt4':
          return {
            type: '4',
            windows: urls.mt4.Windows,
            iphone: urls.mt4.iPhone,
            android: urls.mt4.Android,
            web: urls.mt4.WebTrader
          };
        case 'mt5':
          return {
            type: '5',
            windows: urls.mt5.Windows,
            iphone: urls.mt5.iPhone,
            android: urls.mt5.Android,
            web: urls.mt5.WebTrader
          };
        default:
          return {};
      }
    }
  },
  created() {
    this.registerPath = RegisterRoutePath.register;
    this.downloadPlatforms = downloadPlatforms;
  }
};
</script>

<style lang="scss" scoped>
.infoTable td {
  padding: 6px 20px;
}
</style>
